import React from 'react';
import Modal from './Modal';
import { useLanguage } from '../i18n/LanguageContext';

// Shared "are you sure?" dialog for destructive or hard-to-undo actions -
// the same shape Friends.js already used inline for remove/block, lifted out
// so every such action (logout, leave group, remove member, clear queue,
// start transcription, ...) asks the same way instead of each growing its
// own variant. Controlled: render it with `open` and handle both callbacks.
export default function ConfirmModal({ open, message, confirmLabel, onConfirm, onCancel, danger = true }) {
  const { t } = useLanguage();
  return (
    <Modal mState={{ iShow: open, setiShow: (v) => { if (!v) onCancel(); } }} buttonShow>
      <div className="ConfirmModalBody">{message}</div>
      <div className="ConfirmModalActions">
        <button onClick={onConfirm} className={`SendButton ${danger ? 'cancelColor' : 'primaryColor'}`}>{confirmLabel}</button>
        <button onClick={onCancel} className="SendButton secondaryColor">{t('common.cancel')}</button>
      </div>
    </Modal>
  );
}
